import PhotoSwipeLightbox from '@nodeModules/photoswipe/dist/photoswipe-lightbox.esm.js';

export const initGalleryLightboxes = () => {
    const galleryLightboxes = document.querySelectorAll('.js-gallery-lightbox');

    galleryLightboxes.forEach((galleryLightbox) => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: galleryLightbox,
            children: 'a',
            pswpModule: () => import('@nodeModules/photoswipe/dist/photoswipe.esm.js')
        });

        lightbox.init();
    });
};
